import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/employee-management-system/attendance-tracking/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "attendance-tracking" entry is kept); the seo block below is a fallback.

export const attendanceTracking: ContentPage = {
  slug: "employee-management-system/attendance-tracking",
  template: "hrmsFeature",
  seo: {
    title: "Real-Time Attendance Tracking for Workforce Management",
    description: "Track employee clock-in/out times, breaks, and overtime with accurate, real-time attendance tracking for better payroll processing.",
    keywords: [
      "attendance tracking software",
      "employee attendance management",
      "clock-in system",
      "time tracking software",
      "attendance monitoring",
      "real-time attendance system.",
    ],
    ogImage: "/assets/data/seoimages/attendance-tracking.webp",
  },
  leaf: {
    hero: {
      caption: "Attendance Tracking",
      title: "Accurate Attendance Tracking for Better Workforce Management",
      description: "Track and monitor employee attendance with real-time clock-in/out, ensuring precise records for improved productivity and payroll accuracy.",
      h1: "caption",
    },
    split: {
      title: "Real-Time Attendance Tracking Made Simple",
      bullets: [
        { title: "Clock-in/Clock-out", description: "Real-time tracking of employee hours." },
        { title: "Break Monitoring", description: "Monitor break times and overtime hours." },
        { title: "Attendance Reports", description: "Create detailed attendance reports." },
        { title: "Overtime Tracking", description: "Record and manage employee overtime." },
      ],
      image: "/assets/images/img/product/hrms/employeems/attendance_tracking_image.webp",
      imageAlt: "attendance-tracking",
    },
    cardsHeading: {
      title: "Key Features of Employee Management System",
      description: "Optimize Employee management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Employee Directory",
        href: "/hrms-software/employee-management-system/employee-directory",
        description: "Easily manage employee profiles, personal details, roles, and contact information in a secure and centralized directory for streamlined operations.",
        image: "/assets/images/img/product/hrms/employeems/employee_directory_image.webp",
        imageAlt: "employee_directory_key_features",
      },
      {
        title: "Performance Review",
        href: "/hrms-software/employee-management-system/performance-review",
        description: "Track employee performance, set KPIs, and provide feedback with structured review processes for better productivity and growth.",
        image: "/assets/images/img/product/hrms/employeems/performance_review.webp",
        imageAlt: "performance_review",
      },
      {
        title: "Leave Management",
        href: "/hrms-software/employee-management-system/leave-management",
        description: "Simplify leave requests and approvals with automated workflows, ensuring smooth operations and minimal disruptions.",
        image: "/assets/images/img/product/hrms/employeems/leave_management.webp",
        imageAlt: "leave_management",
      },
      {
        title: "Shift Management",
        href: "/hrms-software/employee-management-system/employee-shift-management",
        description: "Automate and organize shift scheduling, manage shift swaps, and ensure proper staffing with a powerful shift management system.",
        image: "/assets/images/img/product/hrms/employeems/shift_management.webp",
        imageAlt: "shift_management",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Simplify Attendance Tracking for Your Team Today!",
    relatedBlogs: "static",
    metaKey: "attendance-tracking",
  },
  sections: [],
};
